module.exports = __webpack_public_path__ + "static/media/beachday.6588cfe0.ttf";